import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Reviews from "@/components/site/Reviews";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-bone min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <Reviews />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
